<template>
    <layout :title="template.data.name">

        <transition
            enter-active-class="transition duration-300 ease-out transform"
            enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in"
            leave-class="opacity-100"
            leave-to-class="opacity-0">
            <modal
                v-if="flash.success"
                title="Succes"
                :message="flash.success"
            ></modal>
        </transition>

        <transition
            enter-active-class="transition duration-300 ease-out transform"
            enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in"
            leave-class="opacity-100"
            leave-to-class="opacity-0">
            <modal
                v-if="flash.error"
                title="Foutmelding"
                :message="flash.error"
            ></modal>
        </transition>

        <!-- Page title & actions -->
        <div class="px-4 py-4 border-b border-gray-200 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
            <div class="flex-1 min-w-0">
                <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
                    {{ template.data.name }}
                </h1>
            </div>
            <div class="flex mt-4 sm:mt-0 sm:ml-4">
                <span class="rounded-md shadow-sm order-0 sm:order-1 sm:ml-3">
                    <button
                        type="button"
                        @click="editTemplate"
                        class="inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-gray-600 hover:bg-gray-500 focus:outline-none focus:shadow-outline-gray focus:border-gray-700 active:bg-gray-700">
                        Template bewerken
                    </button>
                </span>
                <span class="rounded-md shadow-sm order-0 sm:order-1 sm:ml-3">
                    <button
                        type="button"
                        @click="save"
                        class="inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out border border-transparent rounded-md bg-lightblue-600 hover:bg-lightblue-500 focus:outline-none focus:shadow-outline-lightblue focus:border-lightblue-700 active:bg-lightblue-700">
                        Template opslaan
                    </button>
                </span>
            </div>
        </div>

        <div class="grid grid-cols-2">
            <div class="px-4 py-8">
                <div class="space-y-8 divide-y divide-gray-200">
                    <div>
                        <h3 class="text-lg font-medium leading-6 text-gray-900">
                            {{ template.data.name }}
                        </h3>
                        <p class="mt-1 text-sm text-gray-500">
                            Vul hier de begeleidende tekst voor deze e-mail. De tekst kan in 'Markdown' formaat
                            worden geschreven.
                        </p>

                        <div class="grid grid-cols-1 mt-6 gap-y-6 gap-x-4 sm:grid-cols-6">
                            <div class="sm:col-span-6">
                                <label for="about" class="block text-sm font-medium text-gray-700">
                                    Clues
                                </label>
                                <div class="mt-1">
                                    <textarea
                                        id="about"
                                        rows="3"
                                        :value="form.clues"
                                        @input="update"
                                        :disabled="!canEdit"
                                        class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
                                    ></textarea>
                                </div>

                                <p class="mt-2 text-sm text-gray-500">Voorbeeld:</p>
                                <div class="p-4 mt-4 rounded bg-gray-50" v-html="compiledMarkdown"></div>

                                <div class="sm:col-span-6 mt-8">
                                    <label for="test-email" class="block text-sm font-medium text-gray-700">
                                        Test mail verzenden
                                    </label>
                                    <div class="flex mt-1 rounded-md shadow-sm">
                                        <div class="relative flex-grow focus-within:z-10">
                                            <input
                                                type="email"
                                                id="test-email"
                                                v-model="testMailForm.email"
                                                class="block w-full border-gray-300 rounded-none rounded-l-md focus:ring-lightblue-500 focus:border-lightblue-500 sm:text-sm"
                                                placeholder="bijv. 100890@glr.nl"
                                            />
                                        </div>
                                        <button
                                            @click="sendTestMail"
                                            :disabled="sending"
                                            class="relative inline-flex items-center px-4 py-2 -ml-px text-sm font-medium text-gray-700 border border-gray-300 rounded-r-md bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-lightblue-500 focus:border-lightblue-500 disabled:opacity-50 disabled:cursor-not-allowed">
                                            <span v-if="!sending">Verzenden</span>
                                            <span v-else>Bezig...</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="py-8">
                <iframe
                    class="z-20 w-1/2 overflow-scroll border border-gray-400 lg:absolute"
                    style="height: 80%;"
                    :src="template.data.links.preview"
                    frameborder="0"
                ></iframe>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import Modal from '@/Shared/Modal'
import debounce from 'lodash/debounce'
const marked = require('marked')

export default {
    components: { Layout, Modal },
    props: {
        errors: Object,
        template: Object,
        flash: Object,
    },
    data() {
        return {
            successModal: false,
            sending: false,
            testMailForm: {
                email: '',
            },
            form: {
                clues: this.template.data.clues,
            },
        }
    },
    computed: {
        compiledMarkdown() {
            return marked(this.form.clues)
        },
        canEdit() {
            return window.location.pathname.includes('/edit');
        },
    },
    methods: {
        editTemplate() {
            this.$inertia.get(`/templates/${this.template.data.id}/edit`);
        },
        save() {
            this.$inertia.put(`/templates/${this.template.data.id}`, this.form, {
                onSuccess: () => {
                    this.successModal = true
                    setTimeout(() => (this.successModal = false), 5000)
                },
            })
        },
        update: debounce(function (e) {
            this.form.clues = e.target.value
        }, 300),
        async sendTestMail() {
            if (!this.testMailForm.email) {
                alert('Vul een geldig e-mailadres in.')
                return
            }

            this.sending = true
            await this.$inertia.post(`/templates/${this.template.data.id}/test`, this.testMailForm, {
                onFinish: () => {
                    this.sending = false
                    this.testMailForm.email = ''
                },
            })
        },
    },
}
</script>
